<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 工单系统轮播图 -->
    <WorkOrderBanner></WorkOrderBanner>
    <!-- 工单系统 -->
    <WorkOrderList></WorkOrderList>
    <!-- 多渠道报事报修 -->
    <ReportForRepair></ReportForRepair>
    <!-- 全场景覆盖 -->
    <Cover></Cover>
    <!-- 工单流程闭环 -->
    <ClosedLoop></ClosedLoop>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/mobile/components/TopNav.vue";
import ButtonNav from "../../../../components/mobile/components/BottomNav.vue";
import WorkOrderBanner from '../../../../components/mobile/Product/WorkOrderComponents/WorkOrderBanner.vue'
import WorkOrderList from '../../../../components/mobile/Product/WorkOrderComponents/WorkOrderList.vue'
import ReportForRepair from '../../../../components/mobile/Product/WorkOrderComponents/ReportForRepair.vue'
import Cover from '../../../../components/mobile/Product/WorkOrderComponents/Cover.vue'
import ClosedLoop from '../../../../components/mobile/Product/WorkOrderComponents/ClosedLoop.vue'

export default {
  setup() {
    return reactive({

    });
  },
  components: {
    TopNav,
    ButtonNav,
    WorkOrderBanner,
    WorkOrderList,
    ReportForRepair,
    Cover,
    ClosedLoop,
  },
};
</script>

<style scoped>

</style>
